module.exports = __webpack_public_path__ + "img/appQRcodeC.aa89cfe9.png";